<script>
    export default {
        name: 'CloseIcon',
    };
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="fill-current">
        <path fill="currentColor"
              d="M19.188 19.188a1 1 0 01-1.358.052L10 11.41l-7.83 7.83a1 1 0 01-1.41-1.41L8.59 10 .76 2.17A1 1 0 012.17.76L10 8.59 17.83.76a1 1 0 011.41 1.41L11.41 10l7.83 7.83a1 1 0 01-.052 1.358z" />
    </svg>
</template>
